// Dummy data hook for department headcount
export default function useDepartmentHeadcount() {
  return [
    { department: 'HR', count: 8 },
    { department: 'Engineering', count: 25 },
    { department: 'Sales', count: 15 },
    { department: 'Marketing', count: 10 },
  ];
}
